import Offcanvas from "react-bootstrap/Offcanvas";
import CloseButton from 'react-bootstrap/CloseButton';

function ValueWithChange({ value, change }) {
  if (!change)
    return (
      <>
        <span className={value<0 ? 'val text-danger' : 'val'}>
          {value}
        </span>
      </>
    );

  return (
    <>
      <span className={value<0 ? 'val text-danger' : 'val'}>
        {value}
      </span>
      <span className={change.danger ? 'change text-danger' : 'change'}>
        <i className={change.arrow === 'up'
          ? 'fa-solid fa-arrow-up'
          : 'fa-solid fa-arrow-down'} />
        {change.value}
      </span>
    </>
  );
}

const OPER_LABELS = {
  sales: 'Sales amount',
  refunds: 'Refunds (amount)',
  adjustment: 'Adjustment',
  storage: 'Storage fees',
  promotion: 'Promotion',
  'ad-cost': 'Advertising cost',
  'cost-goods': 'Cost of goods',
  'fee-sales': 'Amazon fees',
  fee: 'Other fees'
};

function AnalyticsDetailsPanel({ show, onClose, data, monthIndex, monthLabel }) {
  if (monthIndex == null) return null;

  if(!data.oos)
    data.oos={};
  if(!data.hijackers)
    data.hijackers={};
  //const isIssues = data.oos[monthLabel] || data.hijackers[monthLabel];

  const isMobile = window.innerWidth < 768;

  const pastIndex= monthIndex ? monthIndex-1 : null;
  //console.log('pastIndex:'+pastIndex+' '+'monthIndex:'+monthIndex);

  const buildData = (idx) => {
    if (idx == null) return {};

    const s = data.series || {};

    return {
      sales: (s.sales?.[idx] ?? 0) + (s['other-sales']?.[idx] ?? 0),
      orgsales: (s.sales?.[idx] ?? 0) - (s['ad-sales']?.[idx] ?? 0),
      adsales: s['ad-sales']?.[idx] ?? 0,
      osales: s['other-sales']?.[idx] ?? 0,
      refunds: s.refunds?.[idx] ?? 0,
      profit: s.profit?.[idx] ?? 0,

      // ❗ тільки якщо є
      opers: data.opers?.[idx],

      bsr: s.bsr?.[idx],
      sessions: s.sessions?.[idx],
      adclicks: s['ad-clicks']?.[idx],
      adacos: s['ad-acos']?.[idx],
      adctr: s['ad-ctr']?.[idx],
      adcv: s['ad-cv']?.[idx],
      cv: s.cv?.[idx],
      tacos: s.tacos?.[idx],
    };
  };

  const currData = buildData(monthIndex);
  const pastData = buildData(monthIndex - 1);

  const inverted = ['refunds','bsr','adacos','tacos'];

  const changes = Object.fromEntries(
    Object.entries(currData)
      .map(([key, value]) => {
        if (value == null || pastData[key] == null) return null;
        let diff = value - pastData[key];
        if (!diff) return null;

        if(diff % 1 !== 0)
          diff=Math.round(diff*100)/100;

        const isPositive = diff > 0;
        return [key, {
          value: `${isPositive ? '+' : ''}${diff}`,
          arrow: isPositive ? 'up' : 'down',
          danger: inverted.includes(key) ? (isPositive ? true : false) : !isPositive
        }];
      })
      .filter(Boolean)
  );

  const opersChanges = {};

  if (currData.opers && pastData.opers) {
    Object.entries(currData.opers).forEach(([key, value]) => {
      const prev = pastData.opers[key];
      if (prev == null || value == null) return;

      let diff = value - prev;
      if (!diff) return;

      diff = Math.round(diff * 100) / 100;

      const isPositive = diff > 0;

      // для витрат: більше = гірше
      const danger = key !== 'sales' && isPositive;

      opersChanges[key] = {
        value: `${isPositive ? '+' : ''}${diff}`,
        arrow: isPositive ? 'up' : 'down',
        danger
      };
    });
  }


  //console.log(changes);

  return (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement={isMobile ? 'bottom' : 'end'}
      className={isMobile ? 'analytics-details vh-100' : 'analytics-details'}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>{monthLabel}</Offcanvas.Title>
        <CloseButton variant="white" onClick={onClose} aria-label="Close" />
      </Offcanvas.Header>

      <Offcanvas.Body>
        {/* SALES */}
        <section className="sales">
          <div className="header">
            <h6>Sales:</h6>
            <span className="value">
              <ValueWithChange
                 value={currData.sales}
                 change={changes.sales}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Organic:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.orgsales}
                 change={changes.orgsales}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Ad:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.adsales}
                 change={changes.adsales}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Other marketpleces:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.osales}
                 change={changes.osales}
               />
            </span>
          </div>
          <div className="item">
            <span className="label text-danger">Refunds (units):</span>
            <span className="value">
              <ValueWithChange
                 value={currData.refunds}
                 change={changes.refunds}
               />
            </span>
          </div>
        </section>

        {/* PROFIT */}
        <section className="profit">
          <div className="header">
            <h6>Profit:</h6>
            <span className="value">
              <ValueWithChange
                 value={currData.profit}
                 change={changes.profit}
               />
            </span>
          </div>

          {currData.opers && (
              <div className="items">
                {Object.entries(currData.opers).map(([key, value]) => (
                  <div className="item" key={key}>
                  <span className="label">
                    {OPER_LABELS[key] ?? key}:
                  </span>
                    <span className="value">
                      <ValueWithChange
                        value={Math.round(value * 100) / 100}
                        change={opersChanges[key]}
                      />
                    </span>
                  </div>
                ))}
              </div>
            )}
        </section>

        {/* ISSUES */}
        {(data.oos[monthLabel] || data.hijackers[monthLabel])  && (
          <section className={(data.oos[monthLabel] || data.hijackers[monthLabel]) ? "issues active" : "issues"}>
            <div className="header">
              <h6>{(data.oos[monthLabel] || data.hijackers[monthLabel]) ? "Issues" : "No issues detected"}</h6>
            </div>

            {data.oos[monthLabel] && (
                <div className="item">
                  <span className="label">
                    Out of Stock:
                  </span>
                  <span className="value text-danger">
                    {data.oos[monthLabel].days} days
                  </span>
                </div>
              )}
              {data.hijackers[monthLabel] && (
                  <div className="item">
                    <span className="label">
                      Hijackers:
                    </span>
                    <span className="value text-danger">
                      {data.hijackers[monthLabel].days} days
                    </span>
                  </div>
                )}
          </section>
          )}

        {/* Statistics */}
        <section className="statistics">
          <div className="header">
            <h6>Statistics:</h6>
          </div>
          {currData.bsr != null && (
            <div className="item">
              <span className="label">BSR:</span>
              <span className="value">
                <ValueWithChange
                   value={currData.bsr}
                   change={changes.bsr}
                 />
              </span>
            </div>
          )}
          <div className="item">
            <span className="label">Organic sessions:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.sessions}
                 change={changes.sessions}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Ad clicks:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.adclicks}
                 change={changes.adclicks}
               />
            </span>
          </div>
        </section>

        {/* Efficiency */}
        <section className="efficiency">
          <div className="header">
            <h6>Efficiency:</h6>
          </div>
          <div className="item">
            <span className="label">Ad ACoS:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.adacos}
                 change={changes.adacos}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Ad CTR:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.adctr}
                 change={changes.adctr}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Ad CV:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.adcv}
                 change={changes.adcv}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">CV:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.cv}
                 change={changes.cv}
               />
            </span>
          </div>
          <div className="item">
            <span className="label">Total ACoS:</span>
            <span className="value">
              <ValueWithChange
                 value={currData.tacos}
                 change={changes.tacos}
               />
            </span>
          </div>
        </section>

        {/* CHANGES */}
        {data.changes?.[monthLabel]?.length > 0 && (
          <section className="changes">
              <div className="header">
                <h6>Changes:</h6>
              </div>
              {data.changes[monthLabel].map((c, i) => (
                    <div className="item" key={i}>
                      <span className="label"><span className="text-danger">•</span> {c.type.charAt(0).toUpperCase() + c.type.slice(1)} change:</span>
                       {c.description}
                    </div>
              ))}
            </section>
          )}

      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default AnalyticsDetailsPanel;
